import { Dialog } from '../container';
import { Button, IconButton } from '../../buttons';

import { Container } from './styles';
import { CommonDialogProps } from './types';

export const CommonDialog = ({
  title,
  onClose,
  children,
  ButtonComponent,
  ...props
}: CommonDialogProps) => {
  return (
    <Dialog {...props}>
      <Container>
        <div className="header-container">
          <h2>{title.toUpperCase()}</h2>
          <IconButton type="button" icon="cross" onClick={onClose} />
        </div>

        <div className="content">{children}</div>

        <div className="bottom-buttons-container">
          <Button
            type="button"
            title="Cancel"
            palette="white"
            variant="stroke"
            onClick={onClose}
          />
          {ButtonComponent && ButtonComponent()}
        </div>
      </Container>
    </Dialog>
  );
};
